import { Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";

interface LinkCellProps {
  to: string | null | undefined;
  label: string | number | null | undefined;
  external?: boolean;
}

const LinkCell = ({ to, label, external = false }: LinkCellProps) => {
  if (!to || !label) return null;

  if (external) {
    return (
      <MuiLink href={to} target="_blank" rel="noreferrer">
        {label}
      </MuiLink>
    );
  }

  return (
    <MuiLink component={Link} to={to} onClick={(e) => e.stopPropagation()}>
      {label}
    </MuiLink>
  );
};

export default LinkCell;
